// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wG4QK","img":"styles_img__u9g07","linkText":"styles_linkText__5LEpl"};